import { createContext, useContext, useEffect } from 'react'
import { useAuth } from './AuthContext'
import { useMasterData as useMasterDataHook } from '../hooks/useMasterData'

export const MasterDataContext = createContext()

export const MasterDataProvider = ({ children }) => {
    const { isAuthenticated } = useAuth()
    const { unidades, imagenesGenericasOfLine, getUnidades } = useMasterDataHook()

    useEffect(() => {
        if (isAuthenticated) {
            getUnidades()
        }
    }, [isAuthenticated])

    const value = {
        unidades,
        imagenesGenericasOfLine,
        getUnidades
    }

    return (
        <MasterDataContext.Provider value={value}>
            {children}
        </MasterDataContext.Provider>
    )
}

export const useMasterData = () => useContext(MasterDataContext)
